import {DomainError} from '@s-ui/domain'

export class GetUserAlertsMatchesTrackingError extends DomainError {
  #cause
  #code
  #message

  static GENERIC_ERROR_CODE = 'generic_get_user_alerts_matches_tracking_error'

  constructor({cause, code, message}) {
    super({cause, code, message})
    this.#cause = cause
    this.#code = code
    this.#message = message
  }

  static isGetUserAlertsMatchesTrackingError({error}) {
    return error instanceof GetUserAlertsMatchesTrackingError
  }

  static create({code, message, cause}) {
    return new GetUserAlertsMatchesTrackingError({code, message, cause})
  }

  static createGenericError({cause}) {
    return GetUserAlertsMatchesTrackingError.create({
      code: GetUserAlertsMatchesTrackingError.GENERIC_ERROR_CODE,
      cause,
      message: 'ERRORS.GET_USER_ALERTS_MATCHES_TRACKING.GENERIC'
    })
  }

  get value() {
    return {
      code: this.#code,
      message: this.message,
      cause: this.cause
    }
  }

  isGenericError() {
    return this.#code === GetUserAlertsMatchesTrackingError.GENERIC_ERROR_CODE
  }

  toJSON() {
    return {
      code: this.#code,
      message: this.#message,
      cause: this.#cause
    }
  }
}
